<template>
  <form style="padding: 20px">  
    <v-snackbar
      top right
      v-model="snackbar"
      :timeout="timeout"
    >
      {{ $t('form.messageSend', locale) }}
      <!-- <v-btn
        color="blue"
        text
        @click="snackbar = false"
      >
        {{$t('common.close')}}
      </v-btn> -->
    </v-snackbar>
    <center style="margin-bottom: 20px;" v-if="data.FormIcon && data.FormIcon.length > 0">
      <button 
        disabled="true"
        style="border-radius:50%;height: 55px;width:55px;text-align:center;padding:5px 5px 2px 5px;opacity:0.7;"
        :style="{ 'background-color': btnBackgroundColor}"
      >
        <v-icon
          style="margin-left: 0px; color: white;font-size:35px;"
          dark
          class="activity-button"
          :style="{ 'color': btnTextColor}"
        >
          {{data.FormIcon}}
        </v-icon>
      </button>
    </center>
    <center class="label-form">
      {{$t('form.name', locale).toUpperCase()}} *
    </center>
    <v-text-field
      solo
      v-model="name"
      :counter="150"
      required
    />
    <center class="label-form" v-if="data.FormRoomNumber">
      {{$t('form.roomNum', locale).toUpperCase()}} *
    </center>
    <v-text-field
      v-if="data.FormRoomNumber"
      solo
      v-model="roomNum"
      :counter="150"
      required
    />
    <center class="label-form" v-if="data.FormNIF">
      NIF *
    </center>
    <v-text-field
      v-if="data.FormNIF"
      solo
      v-model="nif"
      :counter="150"
      required
    />
    <center class="label-form">
      {{$t('form.email', locale).toUpperCase()}} *
    </center>
    <v-text-field
      solo
      v-model="email"
      :counter="150"
      required
    />
    <center class="label-form">
      {{$t('form.phone', locale).toUpperCase()}} *
    </center>
    <v-text-field
      solo
      v-model="phone"
      :counter="150"
      required
    />
    <v-layout wrap v-if="data.FormDateTime">
      <v-flex xs8 style="padding-right: 5px;">
        <center class="label-form">
          {{$t('form.date', locale).toUpperCase()}} *
        </center>
        <v-dialog
          ref="dialogDate"
          v-model="modalDate"
          :return-value.sync="date"
          persistent
          width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="date"
              prepend-icon="mdi-calendar-clock"
              readonly
              v-on="on"
              solo
            />
          </template>
        <v-date-picker
          v-model="date"
          :locale="locale"
          scrollable
          dark
          :min="minDate"
          @input="handleChangeDate"
        >
          <v-spacer />
          <v-btn
            text
            color="primary"
            @click="modalDate = false"
          >
            {{ $t('common.cancel', locale) }}
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="$refs.dialogDate.save(date)"
          >
            {{ $t('common.ok', locale) }}
          </v-btn>
        </v-date-picker>
      </v-dialog>
      </v-flex>
      <v-flex xs4 style="padding-left: 5px;">
        <center class="label-form">
          {{$t('form.time', locale).toUpperCase()}} *
        </center>
        <v-select
          :items="times"
          v-model="time"
          solo
        />
        <!-- <v-text-field
          solo
          v-model="time"
          :counter="150"
          required
        /> -->
      </v-flex>
    </v-layout>
    <center class="label-form" v-if="data.FormNumberOfPeople">
      <!-- {{$t('form.numOfPeople').toUpperCase()}} * -->
      {{ getTranslate(data.FormLblNumberOfItem, locale) }} *
    </center>
    <v-text-field
      v-if="data.FormNumberOfPeople"
      solo
      v-model="numOfPeople"
      type="number"
      required
      :min="0"
      :max="data.FormLimitNumberOfItem"
    />
    <center class="label-form">
      {{$t('form.observations', locale).toUpperCase()}}
    </center>
    <v-textarea
      solo
      v-model="observations"
      :counter="250"
      required
    />
    <v-alert
      v-if="error"
      color="red"
      dense
      text
      icon="mdi-information"
      border="left"
    >
      {{ $t('common.required', locale) }}
    </v-alert>
    <v-btn :color="BGColorSecundary" :style="{ 'color': ColorSecundary}" dark block style="margin-top:20px;height:50px;" @click="handleSubmit">{{ text ? text : $t('common.send', locale) }}</v-btn>    
  </form>
  <!-- <v-alert
    :color="data.Color"
    dense
    text
    :icon="data.Icon"
    border="left"
    :style="{
      'margin': !isSimulation && isDesktop ? '15px 30px 15px 30px' : '15px' 
    }"
  >
    {{text}}
  </v-alert> -->
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import { validationMixin } from 'vuelidate'
  import { required, maxLength, email, sameAs } from 'vuelidate/lib/validators'
  import constants from '@/constants'
  import axios from 'axios'
  import utils from '@/services/utils'
  export default {
    mixins: [validationMixin],
    props: {
      data: {
        type: Object,
        required: true,
        default: null
      },
    },
    data: () => ({
      snackbar: false,
      timeout: 2000,

      modalDate: false,
      times: [],
      loading: false,
      nif: null,

      name: process.env.VUE_APP_ENV === 'development' ? 'Javier' : '',
      roomNum: null,
      email: process.env.VUE_APP_ENV === 'development' ? 'test@descubregroup.com' : '',
      phone: process.env.VUE_APP_ENV === 'development' ? '666666666' : '',
      date: process.env.VUE_APP_ENV === 'development' ? new Date().toISOString().split('T')[0] : '',
      time: process.env.VUE_APP_ENV === 'development' ? '11:11' : '',
      numOfPeople: 1,
      observations: process.env.VUE_APP_ENV === 'development' ? 'Observaciones' : '',
      error: false
    }),
    computed: {
      ...mapState('app',['locale', 'FontContent', 'FontSizeContent', 'ColorContent', 'BGColor', 'BGColorSecundary', 'ColorSecundary']),
      text () {
        return this.data.FormTextBtn ? utils.getTranslation (this.data.FormTextBtn, this.locale) : null
      },
      dates () {
        console.log (this.data.FormTimetable)
      },
      minDate () {
        let date = new Date()
        date.setDate(date.getDate() - 1)
        return date.toISOString()
      },
      btnTextColor () {
        return this.$store.state.app.btnTextColor && this.$store.state.app.btnTextColor !== '' ? this.$store.state.app.btnTextColor : 'white'
      },
      btnBackgroundColor () {        
        return this.$store.state.app.btnBackgroundColor && this.$store.state.app.btnBackgroundColor !== '' ? this.$store.state.app.btnBackgroundColor : this.BGColor
      },
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      isDesktop () {
        return !utils.isMobile()
      },
      nameErrors () {
        const errors = []
        if (!this.$v.name.$dirty) return errors
        !this.$v.name.maxLength && errors.push(this.$t('enterprises.messages.nameMostCharacters'))
        !this.$v.name.required && errors.push(this.$t('enterprises.messages.nameRequired'))
        return errors
      },
    },
    watch: {
      validations() { 
        return {
          name: { required, maxLength: maxLength(50) },
        }
      },
    },
    methods: {
      getTranslate (value) {
        return utils.getTranslation (value, this.locale)
      },
      getTranslate (value, locale) {
        return utils.getTranslation (value, locale)
      },
      handleChangeDate () {
        const dayOfWeek = new Date(this.date).getUTCDay()
        this.times = []
        for (const item of this.data.FormTimetable[dayOfWeek]) {
          this.times.push(`${utils.pad(item.hours, 2)}:${utils.pad(item.minutes, 2)}`)
        }
      },
      handleSubmit () {
        const body = {
          destinationMail: this.data.FormDestinationMail,
          name: this.name,
          roomNum: this.roomNum,
          email: this.email,
          phone: this.phone,
          date: this.date,
          time: this.time,
          numOfPeople: this.numOfPeople,
          observations: this.observations,
          nif: this.nif
        }
        
        if (!this.name || this.name.length === 0
        || !this.email || this.email.length === 0
        || !this.phone || this.phone.length === 0) { 
          this.error = true
          return
        }
        if (this.data.FormNumberOfPeople && (!this.numOfPeople || this.numOfPeople.length ===0)) {
          this.error = true
          return
        }
        if (this.data.FormRoomNumber && (!this.roomNum || this.roomNum.length ===0)) {
          this.error = true
          return
        }
        if (this.data.FormNIF && (!this.nif || this.nif.length ===0)) {
          this.error = true
          return
        }
        if (this.data.FormDateTime && (!this.date || this.date.length ===0
        || !this.time || this.time.length ===0)) {
          this.error = true
          return
        }
        const that = this
        this.loading = true
        axios.post(utils.getAPIURL('utils/form', false), body)
          .then(response => {response
            this.name = ''
            this.roomNum = null
            this.email = ''
              this.nif = ''
            this.phone = ''
            this.date = ''
            this.time = ''
            this.numOfPeople = 1
            this.observations = ''
            this.loading = false
            this.snackbar = true
          })
          .catch(function (error) {
            if (!error.response || error.response.status === 403) {
              // window.location.href = '/#/login'
              that.loading = false
            }
          })
        this.error = false
      }
    }
  }
</script>
<style scoped>
  .label-form {
    margin-bottom: 10px;
  }
</style>
